import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-item-scroll text-left" }
const _hoisted_2 = { class: "flex-container-row flex-wrap gap5" }
const _hoisted_3 = { class: "flex-container-row flex-wrap gap5" }
const _hoisted_4 = {
  orientation: "vertical",
  gap: 5
}
const _hoisted_5 = { class: "flex-container-row flex-wrap gap5" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "flex-container-row redText align-center gap5 padv5"
}
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createBlock(_component_loader_guard, {
    hasLoaded: _ctx.hasLoaded,
    class: "flex-item-scroll"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_card_header, { class: "k-hstack section" }, {
              default: _withCtx(() => [
                _createVNode(_component_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('GeneralData')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_card_body, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_header, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.localize('SerialNo')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card_body, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.masterData.serialNo), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_header, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.localize('MaterialNo')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card_body, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.masterData.materialNo), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_header, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.localize('Description')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card_body, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.masterData.description), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_header, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.localize('ShippingDate')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card_body, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.deliveryDate), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.anyPartnerData)
          ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_card_header, { class: "k-hstack section" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localize('PartnerData')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card_body, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_header, { class: "label" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.localize('SoldTo')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_card_body, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.soldTo), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_header, { class: "label" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.localize('SalesOrderNo')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_card_body, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.salesOrderNo), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_header, { class: "label" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.localize('SalesOrderRef')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_card_body, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.salesOrderRef), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_header, { class: "label" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.localize('ContactPerson')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_card_body, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.contactPerson), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.anyAdminData)
          ? (_openBlock(), _createBlock(_component_card, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_card_header, { class: "k-hstack section" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localize('AdminData')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card_body, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_card_header, { class: "label" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_card_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.localize('EquipmentNo')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_card_body, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.masterData.equipmentNo), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_card_header, { class: "label" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_card_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.localize('ProductionOrderNo')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_card_body, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.productionOrderNo), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_card_header, { class: "label" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_card_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.localize('InternalNote')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_card_body, { class: "text-left" }, {
                              default: _withCtx(() => [
                                (_ctx.masterData.adminOnly)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                      _createVNode(_component_my_icon, {
                                        icon: "warning",
                                        color: "red"
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.localize('onlyVisibleForAdmins')) + " ", 1),
                                      _createVNode(_component_my_icon, {
                                        icon: "warning",
                                        color: "red"
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.hasBomChanges)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                      _createVNode(_component_my_icon, {
                                        icon: "warning",
                                        color: "red"
                                      }),
                                      _createVNode(_component_router_link, { to: { name: 'equipment-deviations', replace: true } }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.localize('equipmentHasChanges')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_my_icon, {
                                        icon: "warning",
                                        color: "red"
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", { innerHTML: _ctx.internalNote }, null, 8, _hoisted_8)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["hasLoaded"]))
}